import type {CaseReturnReason} from "@indebted/api"

const phrasingByReasonID: Record<string, string> = {
	DEADLINE_PASSED: "deadline passed",
}

function phraseReturnReason(reason: CaseReturnReason): string {
	return phrasingByReasonID[reason.ID] ?? reason.Label
}

export {phraseReturnReason}
